import Typesense from 'typesense';
import { shuffle, split, compact } from 'lodash';
import config from '../../../config';
export var getClient = function (apiKey) {
    return new Typesense.Client({
        nodes: shuffle(config.typesense.url.map(function (url) { return ({ url: url }); })),
        apiKey: apiKey,
    });
};
export var getIndex = function (apiKey, index) { return getClient(apiKey).collections(index); };
export var shouldEnableInfix = function (searchString) {
    var terms = compact(split(searchString, config.typesense.delimiterRegex));
    var hasLongNumbers = false;
    var hasShortNumbers = false;
    terms.forEach(function (term) {
        if (/^\d+$/.test(term)) {
            if (term.length >= config.typesense.infixThreshold) {
                hasLongNumbers = true;
            }
            else {
                hasShortNumbers = true;
            }
        }
    });
    return hasLongNumbers && !hasShortNumbers;
};
